import { createContext } from 'react'

import { BabyGrowthContextType } from './types'

export const BabyGrowthContext = createContext<BabyGrowthContextType>(
  {} as BabyGrowthContextType,
)
